require('dotenv').config()

const config = {
    infuraProvider: 'https://eth-ropsten.alchemyapi.io/v2/vh0EktIqkES2w4CjkYpJmZVE9Dip6rry',
    gasPriceURL: 'https://gasprice.poa.network/',
    githubAPI: process.env.REACT_APP_GITHUB_API,
    etherscanAPI: 'https://api.etherscan.io/api?module=contract&action=getabi&address=0xBB9bc244D798123fDe783fCc1C72d3Bb8C189413&apikey=IH3IZFYFBSD155MDR8F21IBG6CWDPPY9WV',
    etherscanAPIKey: 'IH3IZFYFBSD155MDR8F21IBG6CWDPPY9WV',

    liquidityAddress: '0x375Da3e307Ef2E1A9D9e1516f80738Ca52cb7B85',
    governanceAddress: '0x11F724A9A44D5728DA778C1a7DF2DEdba34dca2B',
    rewardsAddress: '0xe3f3869dDD41C23Eff3630F58E5bFA584C770D67',

    lockerAddress: '0xe3f3869dDD41C23Eff3630F58E5bFA584C770D67',
    jobRegistryAddress: '0x18A2eB1cfD4E2A9a698665b1A29Ed97Da76812a9',
    presaleAddress: '0x11F724A9A44D5728DA778C1a7DF2DEdba34dca2B',
    lockerAddressLegacy: '0xf771733a465441437EcF64FF410e261516c7c5F3',
};

export default config;